import { graphql, useStaticQuery } from 'gatsby';
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import PropTypes from 'prop-types';
import React from 'react';

import Logo from '../../../images/cottee-parker-logo.png';
import useStoryblok from '../../../lib/storyblok';
import BurgerMenu from '../burger-menu';

// eslint-disable-next-line no-unused-vars
const Header = ({ isMobileMenuOpen, onBurgerClick, onContactClick, isContactShown }) => {
  function transformMenu(data) {
    return data.content.items.map((item) => {
      const menuItem = {
        text: item.title,
        to: `/${item.link.cached_url}`,
      };

      if (item.sub_menu && item.sub_menu.length > 0) {
        menuItem.submenu = item.sub_menu.map((subItem) => ({
          text: subItem.title,
          to: `/${subItem.link.cached_url}`,
        }));
      }

      return menuItem;
    });
  }

  const data = useStaticQuery(graphql`
    query NavQuery {
      storyblokEntry(full_slug: { eq: "header" }) {
        id
        content
      }
    }
  `);

  const entry = useStoryblok(data.storyblokEntry);

  const menuLinks = transformMenu(entry);

  return (
    <header className="safe-paddings fixed left-0 right-0 top-0 z-10 h-mobile-nav-height bg-primary xl:h-desktop-nav-height">
      <div className="container relative">
        <nav className="flex h-mobile-nav-height items-center justify-between font-heading leading-none lg:py-7 xl:h-desktop-nav-height">
          <div className="w-44 lg:w-40 xl:w-auto">
            <AniLink to="/" className="inline-block" direction="up" bg="#000000" cover>
              <img src={Logo} alt="Cottee Parker" width="217" />
            </AniLink>
          </div>
          <ul className="hidden items-center justify-between leading-none lg:flex lg:gap-14 lg:text-xs xl:gap-16 xl:text-base">
            {menuLinks.map(({ text, to }, index) => (
              <li key={index}>
                <AniLink
                  to={to}
                  className="menu-animate uppercase"
                  activeClassName="menu-animate-active"
                  direction="up"
                  bg="#000000"
                  duration={1}
                  partiallyActive
                  cover
                >
                  {text}
                </AniLink>
              </li>
            ))}
          </ul>
        </nav>

        <BurgerMenu isToggled={isMobileMenuOpen} onClick={onBurgerClick} />
      </div>
      <div className="bg-gradient-bar absolute -bottom-[0.5rem] left-0 right-0" />
    </header>
  );
};

Header.propTypes = {
  isMobileMenuOpen: PropTypes.bool,
  onBurgerClick: PropTypes.func.isRequired,
  onContactClick: PropTypes.func.isRequired,
  isContactShown: PropTypes.bool,
};

Header.defaultProps = {
  isMobileMenuOpen: false,
  isContactShown: false,
};

export default Header;
